import React from "react";
import * as S from "./style";
import { t } from "i18next";

export default function SignUpButton() {
  return <S.GraButton to="/signup">{t("signUp")}</S.GraButton>;
}
